<template src="../templates/normal_fcont_164.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import PrintButton from '../components/PrintButton'
import CreatorProfileVosges from '../components/CreatorProfileVosges'
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import AppDownloadiPrint from '../components/AppDownloadiPrint'
import AppDownloadSmartPanel from '../components/AppDownloadSmartPanel'
import AppDownloadPhotoPlus from '../components/AppDownloadPhotoPlus'
import AppDownloadCreative from '../components/AppDownloadCreative'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  data() {
    return {
      articleId: '164',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,
    PrintButton,CreatorProfileVosges,InfoMachineTranslation,
    AppDownloadiPrint,AppDownloadSmartPanel,AppDownloadPhotoPlus,AppDownloadCreative
  },
  computed: {
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['164-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['164-3']}
      ]
    };
  }
  
};
</script>
<style scoped>
</style>

